var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_3352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9992 57.554C44.769 57.554 57.553 44.77 57.553 29.0001C57.553 13.2303 44.769 0.446289 28.9992 0.446289C13.2293 0.446289 0.445312 13.2303 0.445312 29.0001C0.445312 44.77 13.2293 57.554 28.9992 57.554ZM28.9988 8.03114C17.3988 8.03114 8.02952 17.4004 8.02952 29.0004C8.02952 40.6004 17.3988 49.9696 28.9988 49.9696C40.5988 49.9696 49.968 40.6004 49.968 29.0004C49.968 17.4004 40.5988 8.03114 28.9988 8.03114ZM28.9988 47.2927C18.9157 47.2927 10.7064 39.0835 10.7064 29.0004C10.7064 18.9173 18.9157 10.7081 28.9988 10.7081C39.0818 10.7081 47.2911 18.9173 47.2911 29.0004C47.2911 39.0835 39.0818 47.2927 28.9988 47.2927ZM24.5372 24.0923C24.5372 25.8171 23.1389 27.2154 21.4141 27.2154C19.6893 27.2154 18.291 25.8171 18.291 24.0923C18.291 22.3675 19.6893 20.9692 21.4141 20.9692C23.1389 20.9692 24.5372 22.3675 24.5372 24.0923ZM39.7953 31.4986C39.3492 33.4617 38.2784 35.3355 36.8507 36.7632C34.7984 38.8155 32.0322 39.9755 28.9984 39.9755C28.2845 39.9755 27.6599 40.6001 27.6599 41.314C27.6599 42.0278 28.2845 42.6524 28.9984 42.6524C32.6568 42.6524 36.1368 41.2248 38.7245 38.6371C40.5092 36.8524 41.7584 34.5324 42.383 32.1232C42.5615 31.4094 42.1153 30.6955 41.4015 30.5171C40.5984 30.3386 39.8845 30.7848 39.7953 31.4986ZM36.5835 20.9692C38.2789 20.9692 39.7066 22.3969 39.7066 24.0923C37.922 22.7538 35.3343 22.7538 33.4604 24.0923C33.4604 22.3969 34.8881 20.9692 36.5835 20.9692Z",
    fill: "#39BE43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_3352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalIcon);
export default __webpack_public_path__ + "static/media/successModalIcon.93d2845c7f92c262dbd46443601790c4.svg";
export { ForwardRef as ReactComponent };